import { render } from "./ediBusiness.vue?vue&type=template&id=c33b3160&lang=true"
import script from "./ediBusiness.vue?vue&type=script&lang=js"
export * from "./ediBusiness.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__